import { React, useState } from "react";
import CardSection from "./CardSection";
import DisbursementPledgedGraph from "../content/DisbursementPledgedGraph";
import LineChartCopy from "../content/LineChartCopy";
import NewTablePledged from "../content/NewTablePledged";
import TopUsersNetWorthTable from "../content/TopUsersNetWorthTable";
import DonutChartCarbon from "../utils/DonutChart";
import DigitalAssets from "../content/DigitalAssets";
import PhysicalAssets from "../content/PhysicalAssets";

const AiSection = () => {
  const [isLoading, setIsloading] = useState(false);
  const token = localStorage.getItem("token");
  const [pledgedAvailable, setPledgedAvailable] = useState(true);
  const checkPledged = (value) => {
    setPledgedAvailable(value);
  };
  return (
    <div className="flex flex-col space-y-3 px-[20px] text-[#212b36] bg-[#f1f1f6] pb-4">
      <div className=" bg-white h-24 px-4 flex flex-col justify-between pt-4">
        <p className=" text-xl font-semibold">Artificial Intelligence</p>
        <div className=" text-sm font-semibold">
          {" "}
          <button className=" border-b-[3px] border-[#212b36]  py-[10px]">
            Net Worth
          </button>
        </div>
      </div>
      {/* <CardSection tab={"all"} /> */}
      <div className=" flex justify-between">
        <div className=" w-[49.5%] h-[355px] bg-white rounded-lg">
          <DigitalAssets tab={"all"} />
        </div>
        <div className=" w-[49.5%] h-[355px] bg-white rounded-lg">
          {" "}
          <PhysicalAssets tab={"all"} />
        </div>
      </div>
      <div className=" flex justify-between  ">
        <div className=" w-[49.5%]  bg-white rounded-lg">
          {" "}
          <TopUsersNetWorthTable checkPledged={checkPledged} />
        </div>
        <div className=" w-[49.5%]   bg-white rounded-lg">
          {" "}
          <DonutChartCarbon />
        </div>
      </div>
    </div>
  );
};

export default AiSection;
